<template>
  <div class="container-fluid">
    <div class="chart-page">
      <div class="card mb-2">
        <div class="card-body">
          <div class="chart-title mb-4">每個階段占比</div>
          <div class="form-row">
            <div
              v-for="(chart, index) in seriesData"
              :key="chart.index"
              class="col-sm-12 col-md-4"
            >
              <div class="form-group">
                <apexchart
                  width="400"
                  type="donut"
                  class="chart"
                  :options="chartOptions"
                  :series="chart"
                />
                <p v-if="seriesData" style="text-align: center">
                  {{ dayjs(tableData[index].Month).format("YYYY/MM") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card search-card">
      <div class="card-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <div class="form-row">
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">月份</label>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <el-date-picker
                    class="w-100"
                    type="monthrange"
                    :clearable="false"
                    :picker-options="pickerOptions"
                    v-model="monthRange"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">職缺</label>
                <el-select
                  class="w-100"
                  :filterable="true"
                  clearable
                  value-key="ManpowerDemandNo"
                  placeholder="請選擇"
                  v-model="mdNo"
                >
                  <el-option
                    v-for="opening in openingOptions"
                    :key="opening.ManpowerDemandNo"
                    :label="`${opening.ManpowerDemandNo}-${opening.ManpowerDemandName}`"
                    :value="opening.ManpowerDemandNo"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <button
                type="button"
                class="btn btn-primary"
                style="margin-top: 30px; margin-left: 10px"
                @click="getRecruitProgress"
              >
                查詢
              </button>
              <button
                type="button"
                class="btn btn-info"
                style="margin-top: 30px; margin-left: 10px"
                @click="handleSubmit(exportRecruitProgress)"
              >
                匯出報表
              </button>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <div class="yahome-table-wrap">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="月份">
          <template slot-scope="props">
            <span>{{ dayjs(props.row.Month).format("YYYY/MM") }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="NewResumeQuantity" label="新增履歷" />
        <el-table-column prop="InvitationQuantity" label="已邀約" />
        <el-table-column prop="InterviewQuantity" label="已面談" />
        <el-table-column
          prop="InterviewCompletedQuantity"
          label="已完成面談評估"
        />
        <el-table-column prop="NotArrivedQuantity" label="面談未到" />
      </el-table>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";

export default {
  name: "RecruitProgress",

  data() {
    return {
      // 月分區間
      monthRange: [],
      // 職缺選項
      openingOptions: [],
      mdNo: null,

      tableData: [],

      chartOptions: {
        labels: ["新增履歷", "已邀約", "已面談", "已完成面談評估", "面談未到"],
      },

      // 圓餅圖 data
      seriesData: [],

      // 卡控不能選擇未來時間
      pickerOptions: {
        disabledDate: (date) => {
          let currentDay = this.dayjs();
          return (
            this.dayjs(date) > currentDay
          );
        },
      },
    };
  },

  methods: {
    // 各階段占比 API
    getRecruitProgress() {
      this.updateLoading(true);
      this.$api.chart
        .getRecruitProgress({
          StartMonth: this.dayjs(this.monthRange[0]).format("YYYY-MM"),
          EndMonth: this.dayjs(this.monthRange[1]).format("YYYY-MM"),
          MdNo: this.mdNo,
        })
        .then((response) => {
          if (response.status === 200) {
            this.tableData = response.data;
            this.seriesData = response.data.map((item) => {
              return [
                item.NewResumeQuantity,
                item.InvitationQuantity,
                item.InterviewQuantity,
                item.InterviewCompletedQuantity,
                item.NotArrivedQuantity,
              ];
            });
          }
          this.updateLoading(false);
        });
    },

    // 匯出各階段占比（Excel）
    exportRecruitProgress() {
      this.updateLoading(true);
      this.$api.chart
        .downloadRecruitProgress({
          StartMonth: this.dayjs(this.monthRange[0]).format("YYYY-MM"),
          EndMonth: this.dayjs(this.monthRange[1]).format("YYYY-MM"),
          MdNo: this.mdNo
        })
        .then((response) => {
          if (response.status === 200) {
            let fileName = decodeURIComponent(
              decodeURIComponent(
                response.headers["content-disposition"].split(
                  "filename*=UTF-8''"
                )[1]
              )
            );
            this.updateLoading(false);
            let blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
          }
        });
    },

    async getData() {
      await this.getRecruitProgress();
      // 取得 職缺
      const opening = await this.$api.opening.getOpening();
      this.openingOptions = opening.data.map((item) => {
        return {
          ManpowerDemandNo: item.ManpowerDemandNo,
          ManpowerDemandName: item.ManpowerDemandName,
        };
      });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    const LAST_TWO_MONTH = this.dayjs().subtract(2, "months").format("YYYY-MM");
    const CURRENT_MONTH = this.dayjs().format("YYYY-MM");
    this.monthRange = [new Date(LAST_TWO_MONTH), new Date(CURRENT_MONTH)];
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.chart-title {
  text-align: center;
}
</style>
